import { t } from "@lingui/macro";
import React, { Fragment } from "react";
import styled from "styled-components";
import { Address, formatAddressInOneLine } from "~/core/AddressFormatter";
import { MyPosition, Parking, PinPoint } from "~/guidelines/Icon";
import LabeledInformation from "~/guidelines/LabeledInformation";
import mediaQueries from "~/guidelines/Theme/mediaQueries";
import theme from "~/guidelines/Theme/theme";

const InformationCardsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(6)};
  padding: ${({ theme }) => theme.spacing(0, 5)};
  overflow-x: auto;
  ${mediaQueries.lg()} {
    padding: 0;
  }
`;

type BackgroundColorKey = keyof typeof theme.color.background;

const Card = styled.div<{ backgroundVariant: BackgroundColorKey }>`
  min-width: 300px;
  border: 1px solid ${({ theme }) => theme.color.line.lightSecond};
  border-radius: 4px;
  background-color: ${({ backgroundVariant, theme }) =>
    theme.color.background[backgroundVariant]};
  border-radius: ${({ theme }) => theme.borderRadius.default};

  ${mediaQueries.md()} {
    flex: 1 1;
    flex-basis: 1/3;
  }
`;

export const PlaceDetails = ({
  logeAddress,
  addressDetails,
  distancesDetails,
  parkingsDetails,
  backgroundVariant = "lightSecondary",
}: {
  logeAddress: Address;
  addressDetails: string;
  distancesDetails: string;
  parkingsDetails: string;
  backgroundVariant?: BackgroundColorKey;
}) => {
  return (
    <InformationCardsRow>
      <Card backgroundVariant={backgroundVariant}>
        <LabeledInformation icon={<PinPoint />} title={t`Address`}>
          {formatAddressInOneLine(logeAddress)}
          <br />
          <br />
          {addressDetails.split("\n").map((item, key) => {
            return (
              <Fragment key={key}>
                {item}
                <br />
              </Fragment>
            );
          })}
        </LabeledInformation>
      </Card>

      <Card backgroundVariant={backgroundVariant}>
        <LabeledInformation icon={<MyPosition />} title={t`Distance`}>
          {distancesDetails.split("\n").map((item, key) => {
            return (
              <Fragment key={key}>
                {item}
                <br />
              </Fragment>
            );
          })}
        </LabeledInformation>
      </Card>

      <Card backgroundVariant={backgroundVariant}>
        <LabeledInformation icon={<Parking />} title={t`Parking`}>
          {parkingsDetails.split("\n").map((item, key) => {
            return (
              <Fragment key={key}>
                {item}
                <br />
              </Fragment>
            );
          })}
        </LabeledInformation>
      </Card>
    </InformationCardsRow>
  );
};
